export default "/images/vendor/flag-icon-css/flags/4x3/bq.svg?04ca6698f051e72cf774e2d036039e3b";